export function loadFirebase() {
  return import('./firebase');
}

export function loadFirebaseAuth() {
  return import('./firebase-auth');
}
